import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';
import GameButton from '@components/GameButton';
import { drawTitleScreen } from '@utils/title-screen';

/**
 * StartScene — Balance Out title screen.
 *
 * Renders the title frame (file IK9erYbwssffqvs7qXjo68, node 602:4268)
 * pixel-precisely and exposes a Play button. On click we hand off to
 * GameScene immediately; GameScene re-creates the same layout and runs
 * the full transition (slide-off + scale/progress entrance) — keeping
 * the visual handoff seamless.
 */
export default class StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'StartScene' });
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();

    drawTitleScreen(this);

    this.playButton = new GameButton(this, 529 + 229 / 2, 334 + 64 / 2, 'playButton', {
      hoverScale: 1.08,
      pressScale: 0.92,
      tweenDuration: 120,
    }).onClick(() => {
      this.playButton.disableInteractive();
      enablePointerEvents();
      this.scene.start('GameScene');
    });
    this.playButton.setDepth(5);
  }

  update() {}
}
